import { GLServiceBase, ServiceRoute } from "@/commonui/services";
import { FocusWordModel, FocusWordsRequestModel } from "@/models/focus-words-manager-model";

class FocusWordsManagerServiceClass extends GLServiceBase<any, any> {
	serviceRoute: ServiceRoute = { prefix: "content/v1/focuswords" };

	public getFocusWords(params: FocusWordsRequestModel): Promise<FocusWordModel[]> {
		return this.request.get(this.url(), params);
	}

	public getImageViewingSas(): Promise<any> {
		return this.get("sasurl");
	}

	public getFocusWordData(id, queryParams): Promise<any> {
		return this.request.get(this.url("{id}"), queryParams, id);
	}

	public deleteFocusWord(id): Promise<any> {
		return this.request.del(this.url("{id}"), null, id);
	}

	public addUpdateFocusWord(data): Promise<any> {
		return this.request.put(this.url(), data);
	}
}

export const FocusWordsManagerService = new FocusWordsManagerServiceClass();
